import { Link } from "react-router-dom";
import { Mail, Globe, ArrowUpRight, Linkedin, Twitter, Github } from "lucide-react";
import { ASSETS } from "../lib/assets";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-12 w-12 rounded-xl bg-white grid place-items-center">
                <img src={ASSETS.logos.pjsrs} alt="PJSRS" className="h-11 w-11 object-contain" />
              </div>
              <div className="leading-tight">
                <div className="font-display font-black text-white text-xl">PJSRS Infotech Private Limited</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-teal-400">
                  Inspire · Empower · Entertain
                </div>
              </div>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed">
              An AI-first technology company building intelligent digital products that promote healthier
              lifestyles, celebrate talent, and create engaging entertainment experiences.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                data-testid="footer-email-link"
                href={`mailto:${ASSETS.contact.email}`}
                className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm hover:bg-white/10 transition-colors"
              >
                <Mail className="h-4 w-4 text-teal-400" /> {ASSETS.contact.email}
              </a>
              <a
                data-testid="footer-domain-link"
                href="https://www.pjsrs.com"
                className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm hover:bg-white/10 transition-colors"
              >
                <Globe className="h-4 w-4 text-teal-400" /> {ASSETS.contact.domain}
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-teal-400 mb-4">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white">About</Link></li>
              <li><Link data-testid="footer-link-products" to="/products" className="hover:text-white">Products</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-teal-400 mb-4">Products</div>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-fit2fin" to="/fit2fin" className="hover:text-white inline-flex items-center gap-1">Fit2Fin <ArrowUpRight className="h-3 w-3" /></Link></li>
              <li><Link data-testid="footer-link-cricstory" to="/cricstorylive" className="hover:text-white inline-flex items-center gap-1">CricStoryLive <ArrowUpRight className="h-3 w-3" /></Link></li>
              <li data-testid="footer-item-crazycricket" className="inline-flex items-center gap-2 text-slate-400 cursor-default">CrazyCricket <span className="rounded-full bg-lime-500/10 border border-lime-500/30 px-2 py-0.5 text-[10px] text-lime-300 font-mono uppercase tracking-wider">Soon</span></li>
              {/* SalaryAI hidden until launch
              <li><Link data-testid="footer-link-salaryai" to="/salaryai" className="hover:text-white inline-flex items-center gap-1">SalaryAI <ArrowUpRight className="h-3 w-3" /></Link></li>
              */}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-teal-400 mb-4">PJSRS Stands For</div>
            <ul className="space-y-2 text-sm">
              {[
                ["P", "Progress"],
                ["J", "Journey"],
                ["S", "Strength"],
                ["R", "Rewards"],
                ["S", "Sustainability"],
              ].map(([k, v]) => (
                <li key={v} className="flex items-baseline gap-3">
                  <span className="font-display font-black text-teal-400 w-5">{k}</span>
                  <span className="text-slate-300">{v}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-slate-500">
          <div>© {new Date().getFullYear()} PJSRS Infotech Private Limited. All rights reserved.</div>
          <div className="flex items-center gap-3">
            <a href="#" data-testid="footer-social-linkedin" aria-label="LinkedIn" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 border border-white/10 hover:bg-white/10"><Linkedin className="h-4 w-4" /></a>
            <a href="#" data-testid="footer-social-twitter" aria-label="X" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 border border-white/10 hover:bg-white/10"><Twitter className="h-4 w-4" /></a>
            <a href="#" data-testid="footer-social-github" aria-label="GitHub" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 border border-white/10 hover:bg-white/10"><Github className="h-4 w-4" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
